import { render, staticRenderFns } from "./virtualTrafficStatistics.vue?vue&type=template&id=1f1391fc&"
import script from "./virtualTrafficStatistics.vue?vue&type=script&lang=js&"
export * from "./virtualTrafficStatistics.vue?vue&type=script&lang=js&"
import style0 from "./virtualTrafficStatistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports